// Shared text helpers for catalog features. TSS vite/01 — no React in utils.

// Collapse internal whitespace and trim — preserves single spaces between words.
export function cleanName(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
}

// Trim; empty string becomes null so optional fields are sent as null, not ''.
export function orNull(value) {
    const trimmed = (value || '').trim();
    return trimmed || null;
}
